var _defs, _circle, _path, _circle2, _circle3, _circle4, _path2, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEskizLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.858,
    height: 62.541,
    viewBox: "0 0 133.858 62.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e30033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da047c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 20.427,
    cy: 20.427,
    r: 20.427,
    transform: "translate(6.301 14.192)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M185.946,414.36h-6.162c-.951,2.353-2.4,3.393-4.749,3.393-3.439,0-5.392-2.172-5.473-6.2H186.3v-.632c0-8.188-4.479-13.345-11.535-13.345-6.786,0-11.716,5.245-11.716,12.486,0,7.317,4.749,12.212,11.939,12.212,5.292,0,9.5-2.85,10.945-7.914Zm-6.162-6.875H169.578c.362-3.258,2.353-5.245,5.2-5.245,3.2,0,4.741,2.4,5.01,5.245Z",
    transform: "translate(-147.953 -375.308)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.272,
    cy: 5.272,
    r: 5.272,
    transform: "translate(37.954 51.996)",
    fill: "url(#linear-gradient-2)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 8.092,
    cy: 8.092,
    r: 8.092,
    transform: "translate(32.998 0)",
    fill: "url(#linear-gradient-3)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 3.123,
    cy: 3.123,
    r: 3.123,
    transform: "translate(0 44.043)",
    fill: "url(#linear-gradient-4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M284.967,396.389v2.727h-11.9v8.219H282.7v2.623h-9.628V418.4h11.916v2.727H269.72V396.389Zm13.865,10.137a.682.682,0,0,1-.639.385,1.205,1.205,0,0,1-.585-.189c-.22-.127-.481-.27-.8-.427a7.556,7.556,0,0,0-1.132-.431,5.39,5.39,0,0,0-1.54-.2,4.592,4.592,0,0,0-1.4.2,3.34,3.34,0,0,0-1.059.547,2.392,2.392,0,0,0-.674.8,2.168,2.168,0,0,0-.235.994,1.656,1.656,0,0,0,.385,1.121,3.362,3.362,0,0,0,1.024.77,8.959,8.959,0,0,0,1.452.574c.539.166,1.1.347,1.668.535a16.61,16.61,0,0,1,1.664.632,6.051,6.051,0,0,1,1.452.863,3.955,3.955,0,0,1,1.032,1.267,3.9,3.9,0,0,1,.385,1.806,5.7,5.7,0,0,1-.431,2.234,4.872,4.872,0,0,1-1.279,1.779,6.161,6.161,0,0,1-2.072,1.186,8.514,8.514,0,0,1-2.831.431,8.831,8.831,0,0,1-3.316-.6,8.4,8.4,0,0,1-2.523-1.541l.724-1.155a1.055,1.055,0,0,1,.327-.347.886.886,0,0,1,.485-.119,1.155,1.155,0,0,1,.655.243c.231.162.512.339.84.535a6.352,6.352,0,0,0,1.2.535,5.507,5.507,0,0,0,1.76.243,4.8,4.8,0,0,0,1.571-.235,3.293,3.293,0,0,0,1.121-.628,2.5,2.5,0,0,0,.666-.917,2.845,2.845,0,0,0,.212-1.105,1.841,1.841,0,0,0-.385-1.2,3.281,3.281,0,0,0-1.032-.813,8.339,8.339,0,0,0-1.456-.585c-.547-.166-1.105-.339-1.675-.524a16.25,16.25,0,0,1-1.675-.632,5.907,5.907,0,0,1-1.463-.886,4.033,4.033,0,0,1-1.024-1.325,4.259,4.259,0,0,1-.385-1.906,4.671,4.671,0,0,1,.416-1.926,4.73,4.73,0,0,1,1.209-1.621,5.95,5.95,0,0,1,1.953-1.109,7.805,7.805,0,0,1,2.642-.416,8.368,8.368,0,0,1,3.112.531,7.317,7.317,0,0,1,2.372,1.5l-.689,1.121Zm7.857-10.826v14.97h.793a1.541,1.541,0,0,0,.582-.1,1.391,1.391,0,0,0,.489-.385l5.565-5.923a2.1,2.1,0,0,1,.512-.462,1.352,1.352,0,0,1,.712-.162h2.781l-6.439,6.855a3.9,3.9,0,0,1-1,.917,3.191,3.191,0,0,1,.562.474,4.411,4.411,0,0,1,.474.616l6.84,8.635h-2.746a1.621,1.621,0,0,1-.678-.131,1.155,1.155,0,0,1-.493-.47l-5.75-7.167a1.378,1.378,0,0,0-.508-.478,2.007,2.007,0,0,0-.77-.108h-.882v8.357H303.65V395.723Zm17.716,7.941v17.492h-3.081V403.641Zm.655-5.492a1.926,1.926,0,0,1-.177.836,2.412,2.412,0,0,1-.481.682,2.226,2.226,0,0,1-.709.478,2.176,2.176,0,0,1-.859.173,2.026,2.026,0,0,1-.836-.173,2.2,2.2,0,0,1-.686-.478,2.365,2.365,0,0,1-.466-.689,2.025,2.025,0,0,1-.173-.836,2.176,2.176,0,0,1,.173-.859,2.311,2.311,0,0,1,.466-.709,2.175,2.175,0,0,1,.686-.47,2.022,2.022,0,0,1,.836-.173,2.168,2.168,0,0,1,.859.173,2.206,2.206,0,0,1,.709.481,2.349,2.349,0,0,1,.485.709,2.08,2.08,0,0,1,.177.859Zm16.456,6.805a1.862,1.862,0,0,1-.108.639,1.738,1.738,0,0,1-.3.535l-9.482,12.605h9.57v2.4H328.017v-1.279a1.667,1.667,0,0,1,.1-.531,2.079,2.079,0,0,1,.312-.574l9.532-12.709h-9.413v-2.419h12.967Z",
    transform: "translate(-213.542 -374.152)",
    fill: "#000",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M407.956,472.032h-.323l-1.155,2.973c-.054.127-.089.246-.181.52a4.542,4.542,0,0,0-.173-.481l-1.271-3.012h-.339l1.629,3.851c-.081.212-.262.624-.262.624a.67.67,0,0,1-.7.5,1.105,1.105,0,0,1-.246-.023v.27h.293c.689,0,.824-.385,1.051-.982l1.66-4.236Zm-6.547,0h-.293v3.851h.3v-1.991a1.991,1.991,0,0,1,.22-1.059,1.256,1.256,0,0,1,1.128-.632c.878,0,1.121.57,1.121,1.306v2.372h.3v-2.534a1.279,1.279,0,0,0-1.352-1.429,1.429,1.429,0,0,0-1.421.955v-.847Zm-1.494,1.668v.678a1.352,1.352,0,0,1-1.433,1.344c-.616,0-1-.324-1-.84a.739.739,0,0,1,.451-.7,13.65,13.65,0,0,1,1.718-.331.5.5,0,0,0,.262-.143Zm.77,1.926a.681.681,0,0,1-.2.031c-.277,0-.277-.189-.277-.412v-1.991a1.244,1.244,0,0,0-.22-.893,1.49,1.49,0,0,0-1.155-.412,1.3,1.3,0,0,0-1.479,1.282h.285A1.032,1.032,0,0,1,398.8,472.2c.7,0,1.09.308,1.09.886a.909.909,0,0,1-.054.385c-.1.166-.22.181-1.225.262-.736.062-1.471.308-1.471,1.178,0,.674.474,1.075,1.271,1.075a1.517,1.517,0,0,0,1.5-.924v.189c0,.5.1.647.443.647a.82.82,0,0,0,.308-.046v-.239Zm-5.746-3.435c.87,0,1.421.689,1.421,1.795s-.555,1.779-1.413,1.779c-1.013,0-1.429-.878-1.429-1.772C393.518,472.86,394.042,472.19,394.939,472.19Zm-1.421-.15h-.285v5.226h.3v-2.253a1.383,1.383,0,0,0,1.425,1.005c1.028,0,1.714-.813,1.714-2.037s-.678-2.049-1.722-2.049a1.421,1.421,0,0,0-1.433,1.021v-.917Zm-6,0h-.285v3.851h.3v-2.2c0-.924.443-1.487,1.178-1.487a.866.866,0,0,1,.82.458,1.387,1.387,0,0,1,.112.674v2.538h.3v-2.365a1.383,1.383,0,0,1,.347-1,1.059,1.059,0,0,1,.77-.308c.712,0,.974.451.974,1.074v2.6h.3v-2.7a1.155,1.155,0,0,0-1.217-1.24,1.294,1.294,0,0,0-1.248.824,1.071,1.071,0,0,0-1.121-.824,1.313,1.313,0,0,0-1.256.886v-.77Zm-2.727.15c.886,0,1.463.7,1.463,1.795s-.57,1.748-1.456,1.748-1.487-.689-1.487-1.772S383.905,472.19,384.791,472.19Zm0-.262a2.052,2.052,0,0,0-.008,4.071,1.772,1.772,0,0,0,1.779-2.014A1.811,1.811,0,0,0,384.791,471.928Zm-2.261,1.883h-.308a1.99,1.99,0,0,1-2,1.926,2.2,2.2,0,0,1-2.134-2.5,2.227,2.227,0,0,1,2.149-2.515,1.814,1.814,0,0,1,1.891,1.44h.316a2.1,2.1,0,0,0-2.191-1.733,2.522,2.522,0,0,0-2.484,2.815,2.476,2.476,0,0,0,2.449,2.781,2.253,2.253,0,0,0,2.307-2.222Z",
    transform: "translate(-279.979 -420.102)",
    fill: "#000",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M240.587,130.94H236.47v.285h1.9v5.064h.32v-5.064h1.895Z",
    transform: "translate(-145.399 -80.512)",
    fill: "#000",
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 0.324,
    height: 5.349,
    transform: "translate(90.027 50.428)",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M462.167,396.34a2.207,2.207,0,1,0,2.207,2.207,2.207,2.207,0,0,0-2.207-2.207Zm0,3.809a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,462.167,400.149Zm.8-1.887a.689.689,0,0,1-.316.609l.5.689h-.531l-.412-.562h-.385v.562H461.4v-2.018h.747a.716.716,0,0,1,.816.724Zm-.816.308h-.32v-.6h.32c.385,0,.385.223.385.3s.008.3-.381.3Z",
    transform: "translate(-330.515 -374.546)",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEskizLogo);
export default __webpack_public_path__ + "static/media/eskiz-logo.18c25448630404a233555b184cc67b3c.svg";
export { ForwardRef as ReactComponent };